module.exports = __webpack_public_path__ + "img/loading.465f5518.gif";